module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/paulina-kropiewnicka-fc8dd4548b6538459a9d5a6bb0e51335.png";